<template>
  <div>
    <div class="mt-6 mb-2">
      <CheckBox
        :label="$t('Использовать уведомления')"
        :hint="$t('Включает отправку уведомлений в мессенджеры')"
        :original_value="config.enabled"
        v-model="local_enabled"
    />
    </div>

    <v-expansion-panels multiple :disabled="!local_enabled">
      <!-- TELEGRAM -->
      <v-expansion-panel test-tag="tag-293">
        <v-expansion-panel-header class="settings-panel-header">
          Telegram
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <div class="settings-block">
            <Telegram
              :config="config.telegram_settings"
              :disabled="!local_enabled"
              ref="telegram"
            />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- MAX -->
      <v-expansion-panel test-tag="tag-294">
        <v-expansion-panel-header class="settings-panel-header">
          Max
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <div class="settings-block">
            <Max
              :config="config.max_settings"
              :disabled="!local_enabled"
              ref="max"
            />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-expansion-panels>
  </div>
</template>

<script>
import CheckBox from '../../common/CheckBox.vue'
import Telegram from './telegram'
import Max from './max'

export default {
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      local_enabled: this.config.enabled
    }
  },

  methods: {
    submit() {
      return {
        enabled: this.local_enabled,
        telegram_settings: this.$refs.telegram.submit(),
        max_settings: this.$refs.max.submit()
      }
    }
  },

  components: {
    CheckBox,
    Telegram,
    Max
  }
}
</script>

<style>
.settings-panel-header {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.v-expansion-panel-content__wrap {
  padding: 1px 16px !important;
}

.settings-block {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.v-input {
  margin-top: 0;
}

.v-expansion-panel {
  border-radius: 12px !important;
  margin-bottom: 12px;
}
</style>